import * as React from "react";
import { usePageData } from "../../../../../pages/BookAppointment/context/v3/pages/BookAppointment/context/PageDataContext.js";
import { useRoutingContext } from "../../../../../pages/BookAppointment/context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import Layout from "./Layout.js";
/* empty css            */
const LayoutContainer = (props) => {
  const [_, { currentRoute }] = useRoutingContext();
  const { campaignInfoBanner } = usePageData();
  React.useEffect(() => {
    if (window.scrollY === 0) {
      window.dispatchEvent(new CustomEvent("scroll"));
    } else {
      window.scrollTo(0, 0);
    }
  }, [currentRoute]);
  return /* @__PURE__ */ React.createElement(
    Layout,
    {
      ...props,
      banner: campaignInfoBanner,
      hasNavigation: currentRoute !== "confirmation",
      resetHtmlScrolling: !["", "where"].includes(currentRoute)
    }
  );
};
export {
  LayoutContainer as default
};
//# sourceMappingURL=LayoutContainer.js.map
